import { createSlice } from '@reduxjs/toolkit';

export const ALERT_ERROR:string = 'danger'
export const ALERT_WARN:string = 'warn'
export const ALERT_INFO:string = 'success'

export interface AppState {
    readonly showAlert: boolean,
    readonly alertType: null | string,
    readonly alertText: null | string
    readonly showSignInModal: boolean,
    readonly isLoggedIn: boolean,

}

const initialState: AppState = {} as AppState;

export const appSlice = createSlice({
    name: 'appstate', // not sure what this 'name' is for. For the moment, I'll just call it the same as the reference in store.ts
    initialState,
    reducers: {
      reset: () => initialState,
      errorAlert: (state, action) => {
        state.showAlert = true;
        state.alertType = ALERT_ERROR;
        state.alertText = action.payload;
      },
      warnAlert: (state, action) => {
        state.showAlert = true;
        state.alertType = ALERT_WARN;
        state.alertText = action.payload;
      },
      infoAlert: (state, action) => {
        state.showAlert = true;
        state.alertType = ALERT_INFO;
        state.alertText = action.payload;
      },
      clearAlert: (state) => {
        state.showAlert = false;
        state.alertType = null;
        state.alertText = null;
      },
      showSignIn: (state) => {
        state.showSignInModal = true;
      },
      closeSignIn: (state) => {
        state.showSignInModal = false;
      }
    }
});

export const {errorAlert, warnAlert, infoAlert, clearAlert, showSignIn, closeSignIn} = appSlice.actions


export default appSlice.reducer;